import {
  webAppGetFragmentSocialUploadsByFragmentIdQueryOptions,
  webAppListEditsVideoEditorEditsQueryOptions,
  webAppGetSocialConnectionsConnectionsForStationQueryOptions,
} from '@mi-front/api-v2';
import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useFragment } from '../hooks/useFragment';

/**
 * Preloads data required by secondary fragment tabs to keep tab switches responsive.
 */
export function FragmentViewPreload() {
  const { fragment } = useFragment();
  const queryClient = useQueryClient();

  useEffect(() => {
    const { id: fragmentId, stationId } = fragment;

    const editsOptions = webAppListEditsVideoEditorEditsQueryOptions({ fragmentId });
    void queryClient.prefetchQuery(editsOptions);

    const socialUploadsOptions = webAppGetFragmentSocialUploadsByFragmentIdQueryOptions(fragmentId);
    void queryClient.prefetchQuery(socialUploadsOptions);

    const socialConnectionsOptions =
      webAppGetSocialConnectionsConnectionsForStationQueryOptions(stationId);
    void queryClient.prefetchQuery(socialConnectionsOptions);
  }, [fragment.id, fragment.stationId, queryClient]);

  return null;
}
